// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a5d5a5e","455":"b69d7df8","977":"c312a520"}[chunkId] + ".chunk.js";
};